import { render, staticRenderFns } from "./headPageNew.vue?vue&type=template&id=41b4796b&scoped=true"
import script from "./headPageNew.vue?vue&type=script&lang=js"
export * from "./headPageNew.vue?vue&type=script&lang=js"
import style0 from "./headPageNew.vue?vue&type=style&index=0&id=41b4796b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41b4796b",
  null
  
)

export default component.exports